import { Span } from 'client/widget-components/basicComponents';
import { type ResponsiveStylesProp } from 'client/widget-components/responsive-styles/responsiveStylesService';
import { toCSSObject } from 'client/widget-components/responsive-styles/toCSSObject';
import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import { CUSTOMIZATIONS_DATA_GRABS } from '../constants';

interface PaidAddonLabelProps {
    label: ReactNode;
    price?: number;
    displayedPrice?: string;
    styles?: ResponsiveStylesProp;
}

const PaidAddonLabel = ({
    label,
    price,
    displayedPrice,
    styles,
}: PaidAddonLabelProps) => {
    if (!price || price <= 0 || !displayedPrice) {
        return <>{label}</>;
    }
    return (
        <>
            {label}
            <PaidAddonText
                data-grab={CUSTOMIZATIONS_DATA_GRABS.paidAddonTextDataGrab}
                data-auto='product-customizations-paid-addon-text'
                styles={styles}
            >
                + {displayedPrice}
            </PaidAddonText>
        </>
    );
};

const PaidAddonText = styled(Span)`
    margin-inline-start: 8px;
    font-weight: bold;
    ${({ styles }) => toCSSObject(styles || [])}
`;

export default PaidAddonLabel;
